import { Button, Image } from "react-bootstrap";
import notAuthorized from "../../../images/NotAuthorized.png";
import { ServerInfo } from "../../../services/ServerInfo";
import { LoginManager } from "../../../services/LoginManager";

function NotAuthorized() {

  function logOut() {
    let manager = new LoginManager();
    manager.signout().then(() => {
      localStorage.clear();
      sessionStorage.clear();
      ServerInfo.get().then((environment) => {
        window.location.href = environment.oidcSettings.post_logout_redirect_uri;
      })
    }
    ).catch((errorLogOut: any) => {
    });
  }

  return (
    <div className="d-flex justify-content-center border">
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "400px", marginTop: "150px", borderRadius: "10px" }}      >
        <div className="mx-auto card  mb-3 m-10 center" style={{ textAlign: "center" }}>
          <br />
          <div className="card-body justify-content-center">

            <div> <Image style={{ width: "30%", height: "auto" }} src={notAuthorized}></Image>     </div>
            <br />
            <br />


            <p className="card-text justify-content-center">
              <strong>You are not authorized to view this website <br />
                with the credentials entered.<br /></strong>
              <br />
              <br />

              <small><span style={{ "fontWeight": "bolder" }}>For app assistance please contact:</span></small>
              <br />

              <small>PennDOT IT Service Desk</small>
              <br />
              <small><strong><span style={{ "color": "#2B7C85" }}>717-783-8330 |  855-783-8330</span></strong></small>

              <br />
              <br />

            </p>
            <p style={{ "color": "red" }}><small><strong>PLEASE FOLLOW THE LOGOUT PROCESS TO END THE SESSION.</strong></small></p>
            <Button className="shadow-sm cursor-shadow btn-save btn-default" variant="light" onClick={logOut} type="submit">Logout</Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotAuthorized;
